<template>
    <div>
        <div v-if="$utils.have('/activityShowPlan/addOrUpdate')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.dataEdit.show()">新增计划</el-button>
        </div> 
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="计划生效" min-width="170">
                    <template slot-scope="scope">起:{{scope.row.startDate}}<br/>至:{{scope.row.endDate}}</template>
                </el-table-column>
                <el-table-column prop="dateType" label="展示日期">
                    <template slot-scope="scope">
                        <template v-if="scope.row.dateType == 1">每天</template>
                        <template v-else-if="scope.row.dateType > 1">
                            <span v-for="(item,index) in scope.row.dateValue.split(',')" :key="index">
                                每{{scope.row.dateType == 2 ? '周' : '月'}}{{item == 32 ? '最后一天' : item}}<template v-if="index < scope.row.dateValue.split(',').length - 1">/</template>
                            </span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="展示时间" min-width="170">
                    <template slot-scope="scope">{{scope.row.startTime}} 至 {{scope.row.endTime}}</template>
                </el-table-column>
                <el-table-column prop="showApproval" label="展示对象">
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.showApproval.split(',')" :key="index">
                            {{item == 2 ? '报批申请中的演出' : '还未申请报批的演出'}}<template v-if="index < scope.row.showApproval.split(',').length - 1">/</template>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="exclCity" label="展示范围">
                    <template slot-scope="scope">
                        {{scope.row.exclCity == 0 ? '全国' : '部分城市'}}
                    </template>
                </el-table-column>
                <el-table-column prop="showTerminal" label="展示终端">
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.showTerminal.split(',')" :key="index">
                            {{terminal.get(item)}}<template v-if="index < scope.row.showTerminal.split(',').length - 1">/</template>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activityShowPlan/addOrUpdate')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="$refs.dataEdit.show(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/activityShowPlan/delete')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <Edit ref="dataEdit" @onUpdate="getDataList"></Edit>
    </div>
</template>
<script>
import Edit from './components/edit';
export default {
    components:{Edit},
    data(){
        return{
            data: null,
            dataList: null,
            params:{pageNo:1,pageSize:this.$pageSizes[0]},
            listLoading: false,
        }
    },
    computed:{
        terminal(){
            return new Map([
                ['1','APP'],['2','WAPCN'],['3','WAPEN'],['4','PC'],
            ])
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activityShowPlan/pageList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        del(id){
            this.$confirm('确认删除当前展示计划?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/activityShowPlan/delete',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => {});
        },
    }
}
</script>